import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {FB_APP_ID} from "./constants/ConfigFromBuildEnvironment";

window.fbAsyncInit = function() {
    window.FB.init({
        appId: FB_APP_ID,
        autoLogAppEvents: true,
        xfbml: false,
        version: 'v8.0'
    });
    ReactDOM.render(<App />, document.getElementById('root'));
};


